module.exports = __webpack_public_path__ + "static/media/service-ecommerce.2488a7e0.png";